import { Container, DisplayObject, Point } from 'pixi.js';

export const Layers = {
  Ground: 0,
  GroundObjects: 1,
  Walls: 2,
  Furniture: 3,
  Characters: 4,
  Effects: 5,
  UI: 6
} as const;

export type Layer = keyof typeof Layers;

export class LayerSystem {
  private readonly root: Container;
  private readonly layers: Map<Layer, Container> = new Map();

  constructor(root: Container) {
    this.root = root;
    this.initializeLayers();
  }

  public add(displayObject: DisplayObject, layer: Layer, gridPosition: Point): void {
    const container = this.layers.get(layer);
    if (!container) {
      throw new Error(`Layer ${layer} is not initialized`);
    }

    displayObject.zIndex = this.calculateDepth(gridPosition, layer);
    container.addChild(displayObject);
  }

  public getLayer(layer: Layer): Container {
    const container = this.layers.get(layer);
    if (!container) {
      throw new Error(`Layer ${layer} is not initialized`);
    }

    return container;
  }

  public calculateDepth(gridPosition: Point, layer: Layer): number {
    const layerOffset = Layers[layer] * 100000;
    const depth = gridPosition.y * 1000 + gridPosition.x;
    return layerOffset + depth;
  }

  private initializeLayers(): void {
    (Object.keys(Layers) as Layer[]).forEach((layer) => {
      const container = new Container();
      container.sortableChildren = true;
      this.layers.set(layer, container);
      this.root.addChild(container);
    });
  }
}
